import { TooltipRenderProps } from "react-joyride";
import { IconButton, Typography } from "@material-ui/core";
import Card from "../Card";
import Button from "../Button";
import { useStyles } from "./styles";
import { Close } from "../../icons";

const TourTooltip = ({
  continuous,
  index,
  step,
  backProps,
  closeProps,
  primaryProps,
  tooltipProps,
  skipProps,
}: TooltipRenderProps) => {
  const styles = useStyles();

  return (
    <div {...tooltipProps}>
      <Card
        border={false}
        className={styles.root}
        action={
          <IconButton color="secondary" {...skipProps}>
            <Close />
          </IconButton>
        }
        title={step?.title}
      >
        <Typography> {step.content} </Typography>
        <div className={styles.footer}>
          <Button
            style={{
              visibility: index > 0 ? "initial" : "hidden",
            }}
            variant="primary"
            size="sm"
            color="red"
            {...backProps}
          >
            {backProps.title}
          </Button>
          {!continuous && (
            <Button variant="primary" size="sm" color="red" {...closeProps}>
              {closeProps.title}
            </Button>
          )}
          {continuous && (
            <Button variant="primary" size="sm" color="blue" {...primaryProps}>
              {primaryProps.title}
            </Button>
          )}
        </div>
      </Card>
    </div>
  );
};

export default TourTooltip;
